import {
  pushAnalyticsEvent, sha256,

} from '../helpers';
import Vuex from 'vuex';
import EventBus from '../eventBus';
import {
  Vue,
  cookies,
  servicesURL,
  analyticsEvents,
  getCookie,
  setCookie,
  headers,
  deviceID, payfortAccessCode, payfortMerchantIdentifier
} from '../constants/constants';
import { serverData } from '../data-from-server';
import {
  payload
} from '../models/general.model'
import {
  LoginFormRequest, SignupFormRequest
} from '../models/auth.model'
import {
  Basket, BasketCompact, OrderItemRequest, BasketItem, CreateBasketRequest, CreateGroupBasketRequest, UserBasketStateRequest, BasketUserAddresses, BasketLoadersEnum, BasketCategory, MapEnumToText, ItemAggregate, GroupBasket, GroupBasketUser, relatedRestaurants
} from '../models/basket.model'
import { staticContent } from '../localisation/detect-lang';
import { OrderCompactResponse, orderDetails } from '../models/myOrders.model'

import axios from 'axios'
import * as moment from "moment";
import { json } from 'body-parser';
import { pushGoogleAnalytics4Event } from '../lib/google-analytics';
import { GA4Events } from '../lib/google-analytics/config';

Vue.use(Vuex);



export const initiateRequests = () => {
  axios.defaults.headers.common['lang'] = getCookie(cookies.lang).toUpperCase() ? getCookie(cookies.lang).toUpperCase() : 'EN';
  axios.defaults.headers.common['Device-Model'] = navigator.userAgent;
  axios.defaults.headers.common['Accept'] = "application/json";
  axios.defaults.headers.common['Content-Type'] = "application/json";
  axios.defaults.headers.common['X-Device-Id'] = deviceID;
  getCookie('Authorization') && (axios.defaults.headers.common['Authorization'] = 'Bearer ' + getCookie('Authorization'));
  headers['lang'] = getCookie(cookies.lang).toUpperCase() ? getCookie(cookies.lang).toUpperCase() : 'EN';
  headers['Device-Model'] = navigator.userAgent;
  getCookie('Authorization') && (headers['Authorization'] = 'Bearer ' + getCookie('Authorization'));
  axios.interceptors.response.use(undefined, err => {
    let res = err.response;
    if (getCookie('webRefreshToken') && res && res.status === 401 && !(err.config.headers && err.config.headers.retryCount > 2) && !(res.data.errorCode && res.data.errorCode.startsWith('AUTH-'))) {
      return new Promise((resolve, reject) => {
        axios.put(servicesURL.user.login, decodeURIComponent(getCookie('webRefreshToken')), {
          headers: {
            "Content-Type": "application/json"
          }
        })
          .then(res => {
            setCookie('Authorization', res.data.accessToken, '/');
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.accessToken;
            headers['Authorization'] = 'Bearer ' + res.data.accessToken;
            setCookie('webRefreshToken', res.data.refreshToken, '/');
            err.config.__isRetryRequest = true;
            err.config.headers.retryCount ? err.config.headers.retryCount = err.config.headers.retryCount + 1 : err.config.headers.retryCount = 1;
            err.config.headers.Authorization = 'Bearer ' + res.data.accessToken;
            resolve(axios(err.config));
          }).catch(
            error => {
              console.log('Refresh login error: ', error);
              // window.location.href = '/login?origin=' + window.location.pathname;
              reject(error);
            }
          );
      });
    }
    else {
      if (res && res.data.errorCode === 'AUTH-003' || (err.config.headers && err.config.headers.retryCount > 2) || !getCookie('webRefreshToken')) {
        setCookie('Authorization', '', '/');
        setCookie('webRefreshToken', '', '/');
      }
      return Promise.reject(err);
    }
  });
};
initiateRequests();

const initRelatedRestaurants: relatedRestaurants = {
  count: 0,
  page: 0,
  data: []
}

/**********************Initial state for Basket ************************/
const initBasketFn = (): Basket => {
  return {
    visible: false,
    showCreateBasket: false,
    showAreaZone: false,
    loading: null,
    disableSubmit: false,
    uuid: null,
    didToggleDeliveryTime: false,
    ref: {
      areaUUID: null,
      zoneUUID: null,
      restaurant: {
        uuid: null,
        shortCode: null,
        name: null,
        acceptPromo: false,
        onlinePayment: false
      },
      branch: {
        uuid: null,
        shortCode: null,
        ramadanSettings: null
      },
      address: {
        uuid: null,
        ref: {
          cityUUID: null,
          areaUUID: null,
          zoneUUID: null
        },
        data: {
          fullName: null,
          phoneNumber: null,
          location: null,
          address: null,
          deliveryInstructions: null,
          buildingNumber: null,
          floor: null,
          apartmentNumber: null,
          companyName: null,
          company: false,
          default: false,
          verified: false,
        }
      },
      card: null,
      promo: null
    },

    data: {
      receipt: {
        subTotal: null,
        tax: null,
        deliveryFee: null,
        deliveryCharges: {
          deliveryFees: null,
          serviceFees: null,
        },
        total: null,
        taxOnDelivery: null,
        paidWithWallet: false,
        walletDiscount: 0
      },
      categories: null,
      minimumOrderValue: null,
      isLocked: false,
      paymentType: "CASH_ON_DELIVERY",
      deliveryTime: 'NOW',
      basketDataExist: true
    },
    payment: {
      method: "CASH_ON_DELIVERY",
      cardUUID: null,
      paymentTypeEnum: {
        CASH_ON_DELIVERY: "CASH_ON_DELIVERY",
        CREDIT_CARD: "CREDIT_CARD"
      },
    },
    checkout: {
      currentStep: 0,
      steps: [
        {
          step: 1,
          title: staticContent.restaurant.checkout.steps.step1,
          optional: false
        },
        {
          step: 2,
          title: staticContent.restaurant.checkout.steps.step2,
          optional: false
        },

      ],
      showCheckoutModal: false,
      showOrderSuccess: false, // checkoutDone in old model
      placeOrderError: null,
      confirmation: null
    },
    errorsEnumToText: {
      ITEM_UNAVAILABLE_IN_BRANCH: staticContent.restaurant.basket.errors.ITEM_UNAVAILABLE_IN_BRANCH,
      ITEM_UNAVAILABLE_NOW: staticContent.restaurant.basket.errors.ITEM_UNAVAILABLE_NOW,
      ITEM_UNAVAILABLE_FOR_DELIVERY: staticContent.restaurant.basket.errors.ITEM_UNAVAILABLE_FOR_DELIVERY,
      ITEM_PRICE_CHANGE: staticContent.restaurant.basket.errors.ITEM_PRICE_CHANGE,
    },
    basketItemErrors: null
  }
};

const initItemAggregateFn = (): ItemAggregate => {
  return {
    uuid: null,
    availability:{
      availableForDelivery: false,
      availableInBranch: false,
    },
      description: null,
      extraCategories: [{
        uuid: null,
        availability:{
          availableForDelivery: false,
          availableInBranch: false,
          timeAvailability: {
            availableFromDate: null,
            availableFromTime: null,
            availableToDate: null,
            availableToTime: null,
          },
        },
          categoryType: null,
          description: null,
          items: [],
          maximumAllowedExtra: 0,
          minimumAllowedExtra: 0,
          name: null,
          sizeRestricted: false
        
      }],
      isLikedByUser: false,
      likesCount: 0,
      name: null,
      photoUrl: null,
      photos: [],
      priceAvailable: false,
      sequence: 0,
      sizes: [{
        uuid: null,
        sizeUUID: null,
        name: null,
        sizeName: null,
        price: 0
        
      }],
      tags: []
    }
}

const initCompactBasketFn = (): BasketCompact => {
  return {
    uuid: null,
    loading: false,
    ref: { restaurantUUID: null },
    data: {
      isLocked: false,
      totalPrice: null,
      subTotal:null,
      itemCount: null,
      isGroup: false,
      restaurantName: null
    }
  }
}

const initBasket: Basket = initBasketFn();

const initCompactBasket: BasketCompact = initCompactBasketFn();

const initTempBasketItem: BasketItem = {
  basketItemUUID: null,
  quantity: null,
  price: null,
  comment: null,
  itemUUID: null,
  itemName: null,
  sizeUUID: null,
  sizeName: null,
  extras: null,
  isTemp: true
}
/*******************Initial state for OrderItem*********************/

const initOrderItemRequest: OrderItemRequest = {
  itemSizeUUID: null,
  quantity: null,
  extras: null,
  comment: null,

}
const initCreateBasketRequest: CreateBasketRequest = {
  restaurantUUID: serverData.restaurantUUID,
  branchUUID: serverData.restaurantHeader && serverData.restaurantHeader.branchUUID,
  zoneUUID: null,
  firstItem: initOrderItemRequest
}

/************************** Intial state for start group ordering *************************/

const initCreateGroupBasketRequest: CreateGroupBasketRequest = {
  restaurantUUID: serverData.restaurantUUID,
  branchUUID: serverData.restaurantHeader && serverData.restaurantHeader.branchUUID,
  zoneUUID: null,
}

const initUserBasketStateRequest: UserBasketStateRequest = {
  restaurantUUID: serverData.restaurantUUID,
  basketUUID: null
}

const initGroupBasket: GroupBasket = {
  visible: false,
  uuid: null,
  itemsCount: null,
  ref: {
    restaurant: {
      uuid: null,
      name: null,
      shortCode: null,
      logo: null,
      acceptPromo: false,
      onlinePayment: false
    },
    branch: {
      uuid: null,
      shortCode: null,
      ramadanSettings: null,
    },
    adminUserUUID: null,
    zoneUUID: null
  },
  data: {
    link: null,
    receipt: {
      subTotal: null,
      tax: null,
      deliveryFee: null,
      deliveryCharges: {
        deliveryFees: null,
        serviceFees: null,
      },
      total: null,
      taxOnDelivery: null,
      paidWithWallet: false,
      walletDiscount: 0
    },
    minimumOrderValue: 0,
    isLocked: false,
    error: null,
    users: null,
  }
}
/*****************************Initial Basket User Adresses***************************************** */
const initBasketUserAddresses: BasketUserAddresses = {
  applicable: null,
  notApplicable: null
}

const initMyOrdersFn = (): OrderCompactResponse => {
  return {
    count: 0,
    page: 0,
    data: []
  }
}

const initOrderDetails = (): orderDetails => {
  return {
    orderUUID: null,
    ref: {
      restaurantLogo: null,
      restaurantName: null,
      restaurantShortCode: null,
      restaurantUUID: null,
      userUUID: null
    },
    data: {
      categories: [{
        categoryUUID: null,
        categoryName: null,
        items: [{
          itemName: null,
          itemUUID: null,
          orderItemUUID: null,
          price: 0,
          quantity: 0,
          sizeName: null,
          sizeUUID: null,
          extras: [{
            categoryName: null,
            categoryUUID: null,
            extraItems: [{
              itemName: null,
              itemUUID: null,
              orderItemExtraUUID: null,
              price: 0,
              sizeName: null,
              sizeUUID: null,
            }]
          }]
        }]
      }],
      receipt: {
        subTotal: 0,
        tax: 0,
        deliveryFee: 0,
        deliveryCharges: {
          deliveryFees: null,
          serviceFees: null,
        },
        total: 0,
        taxOnDelivery: false,
        totalBeforeDiscount: 0
      },
      orderDeliveryAddress: {
        data: {
          address: null,
          apartmentNumber: 0,
          buildingNumber: null,
          company: false,
          companyName: null,
          deliveryInstructions: null,
          floor: null,
          fullName: null,
          location: {
            lat: null,
            lon: null
          },
          orderOrigin: null,
          phoneNumber: null,
        },
        ref: {
          areaUUID: null,
          cityUUID: null,
          userAddressUUID: null,
          zoneUUID: null
        },
        trace: {
          created: {
            at: null,
            by: null
          },
          updated: {
            at: null,
            by: null
          }
        }
      },
      createdAt: null,
      acceptedAt: null,
      deliveryTime: null,
      estimatedDeliveryTime: null,
      group: false,
      orderShortCode: null,
      orderStateEnum: null,
      paymentTypeEnum: null,
      promoDetails: null,
      orderUUID: null,
      actionType: null,
      driver: {
        driverName: null,
        driverUUID: null,
        driverPhoneNumber: null,
        driverPhoto: null,
        customerUUID: null,
        tripStatus: null,
        location: { lat: null, lon: null }
      },
      acceptedTime: null,
      outForDeliveryTime: null,
      expectedCookingTime: null,
      tripUUID: null,
      tripStatus: ""
    }
  }

}

const initMyOrders: OrderCompactResponse = initMyOrdersFn();


/**************************Start Store**********************************/
export const store = new Vuex.Store({
  state: {
    promoForm: {
      loading: false,
      openedForm: null,
      message: false,
      currentStep: 1,
      flag: true,
      steps: [
        {
          step: 1,
          title: staticContent.gifting.steps.step1,
          optional: false
        },
        {
          step: 2,
          title: staticContent.gifting.steps.step2,
          optional: false
        },

      ],
      payment: {
        method: "CREDIT_CARD",
        paymentTypeEnum: {
          CREDIT_CARD: "CREDIT_CARD",
          CASH: "CASH_ON_DELIVERY"
        },
        selectedCard: null
      },
      form: {
        errors: null,
        loading: false,
        data: {
          paymentTypeEnum: "CREDIT_CARD",
          prefix: null,
          sms: null,
          phoneNumbers: [],
          amount: 0,
          email: null,
          phoneNumber: null,
          cardUUID: null
        }
      },
    },
    topup: {
      loading: false,
      payment: {
        cardUUID: null,
        selectedCard: null,
      },
      errors: null
    },
    cardRequest: {
      loading: false,
      error: false,
      errorMessage: '',
      merchant_reference: '',
      signature: '',
      token_name: '',
      uuid: '',
      fort_id: '',
      expiry_date: '',
      payment_option: '',
      card_number: '',
    },
    lastOrder: {},
    search: {
      autocomplete: {
        data: [],
        debounce: null,
        show: false,
        ajaxRequest: null
      }
    },
    showCheckoutModal: false,
    xTracking: {
      page: serverData.xTracking ? [serverData.xTracking] : null,
      autocomplete: null
    },
    profile: null,
    promoBanner: serverData.promoBanner ? serverData.promoBanner : null,
    creditCards: [],
    cardsLoading: false,
    deliveryStatus: {
      areaUUID: getCookie(cookies.userArea) || null,
      isDeliver: null
    },
    restaurantDeliveryData: {
      allDeliveryFee: null,
      deliveryFee: null,
      allDeliveryDuration: null,
      deliveryDuration: null
    },
    relatedRestaurants: initRelatedRestaurants,
    /******Start Basket state data*******/
    basket: initBasketFn(),
    isGroupMember: false,
    tempBasketItem: initTempBasketItem,
    basketCompact: initCompactBasketFn(),
    basketUserAddresses: initBasketUserAddresses,
    itemAggregate: initItemAggregateFn(),
    basketItemModal: null,
    refreshConfigurations: {
      basketCompactInterval: 30,
      basketSummaryInterval: 15
    },
    /******End Basket state data*******/
    /**********Order state************/
    orderItemRequest: initOrderItemRequest,
    createBasketRequest: initCreateBasketRequest,
    createGroupBasketRequest: initCreateGroupBasketRequest,
    userBasketStateRequest: initUserBasketStateRequest,
    branchMenus: null,
    commonTagUUID: null,
    menuLoading: false,
    groupBasket: initGroupBasket,
    promoRequest: {
      code: null,
      errors: null
    },
    cart: {
      visible: false,
      basketItemModal: null,
      disableSubmit: false,
      flatSelectedExtraItems: {},
      basketData: {
        subTotal: 0,
        deliveryFee: null,
        tax: null,
        taxOnDelivery: null,
        orderTax: 0,
        total: 0,
        minimumOrderValue: 0,
        promo: {
          promoUUID: null,
          discount: null,
          minOrderValue: null,
          maxMoneyValue: null
        },
        promoForm: {
          promoCode: null,
          errors: null
        }
      },


      order: {
        items: [],
        branchUUID: serverData.restaurantHeader && serverData.restaurantHeader.branchUUID,
        userAddressUUID: null,
        promoUUID: null
      }
    },
    alert: {
      title: "",
      description: "",
      icon: "/public/img/discard-basket.svg"
    },
    checkoutCycle: {
      step: 0,
      selectedAddressObj: null,
      flattenOrderItems: null,
      placeOrderError: null,
      confirmationData: {
        orderUUID: null,
        orderShortCode: null,
        itemsCount: null,
        deliveryFee: null,
        subTotal: null,
        tax: null,
        total: null,
        promoDetails: null
      },
      addressForm: {
        fullName: null,
        phoneNumber: null,
        cityUUID: null,
        areaUUID: null,
        zoneUUID: null,
        location: null,
        address: null,
        landmark: null,
        buildingNumber: null,
        floorNumber: null,
        apartmentNumber: null,
        isCompany: false,
        companyName: null,
        default: false,
        addressUUID: null,
        addressTouched: false,
        mapTouched: false
      },
      checkoutDone: false
    },
    loginForm: {
      errors: null,
      loading: false
    },
    signupForm: {
      errors: null,
      newUser: false,
      loading: false
    },
    showGiftForm: false,
    basketState: null,
    groupLink: null,
    lockBasketHasError: false,
    checkoutLoadingData: null,
    checkoutLoadingDataError: false,
    startGroup: false,
    unavailableItems: [],
    iftarType: null,
    tastyOffers: {
      count: 0,
      page: 1,
      data: null
    },
    sharedOrderLink: null,
    currentOrders: initMyOrdersFn(),
    previousOrders: initMyOrdersFn(),
    selectedOrder: initOrderDetails(),
    selectedTrip: {},
    selectedOrderType: 'CURRENT',
    myOrdersPageLoader: false,
    myOrdersPageError: false,
    currentOrdersLoader: false,
    previousOrdersLoader: false,
    reOrderFromMyOrderPage: false,
    cardVerification: {
      error: false,
      errorCode: null

    },
    resumeOrder: {
      error: false,
      loading: false
    },
  },
  getters: {
    getTastyOffers(state) {
      return state.tastyOffers
    },
    getAlert(state) {
      return state.alert
    },
    getRefreshConfigurations(state) {
      return state.refreshConfigurations
    },
    getProfileData(state) {
      return state.profile
    },
    getLoginErrors(state) {
      return state.loginForm.errors
    },
    getSignupErrors(state) {
      return state.signupForm.errors
    },
    getLoginLoading(state) {
      return state.loginForm.loading
    },
    getSignupLoading(state) {
      return state.signupForm.loading
    },
    getUserProfile(state) {
      return state.profile;
    },
    getCart(state) {
      return state.cart
    },
    getBasket(state) {
      return state.basket
    },
    getGroupBasket(state) {
      return state.groupBasket
    },
    getBasketItemsCount(state) {
      return state.basketCompact.data.itemCount
    },
    getAutocomplete(state) {
      return state.search.autocomplete
    },
    isUser(state) {
      return !(!state.profile || (state.profile && !state.profile.data.profile))
    },
    getPromoRequest(state) {
      return state.promoRequest
    },
    getBasketUserAddresses(state) {
      return state.basketUserAddresses
    },
    getBasketItemModal(state) {
      return state.basketItemModal
    },
    getLockHasError(state) {
      return state.lockBasketHasError
    },
    getcheckoutLoadingData(state) {
      return state.checkoutLoadingData
    },
    getcheckoutLoadingDataError(state) {
      return state.checkoutLoadingDataError
    },
    getCreatePromoErrors(state) {
      return state.promoForm.form.errors
    },
    getCreatePromoLoading(state) {
      return state.promoForm.form.loading
    },
    getShowGiftForm(state) {
      return state.showGiftForm;
    }
  },
  mutations: {
    updateLastOrder: (state, order) => {
      state.lastOrder = order;
    },
    updateLastOrderState: (state, orderState) => {
      state.lastOrder.data.orderStateEnum = orderState.state;
      state.lastOrder.data.estimatedDeliveryTime = orderState.expectedDeliveryTime;
      state.lastOrder.data.acceptedTime = orderState.acceptedTime;
      state.lastOrder.data.outForDeliveryTime = orderState.outForDeliveryTime
      state.lastOrder.data.actionType = orderState.actionType;
    },
    updateReOrderFromMyOrderPage: (state, val) => {
      state.reOrderFromMyOrderPage = val
    },
    updateMyOrdersPageLoader: (state, val) => {
      state.myOrdersPageLoader = val;
    },
    updateMyOrdersPageError: (state, val) => {
      state.myOrdersPageError = val;
    },
    updateSelectedOrderState: (state, res) => {
      state.selectedOrder.data.orderStateEnum = res.state
      state.selectedOrder.data.estimatedDeliveryTime = res.expectedDeliveryTime
      state.selectedOrder.data.outForDeliveryTime = res.outForDeliveryTime;
      state.selectedOrder.data.expectedCookingTime = res.expectedCookingTime;
      state.selectedOrder.data.tripUUID = res.tripUUID;
      state.selectedOrder.data.acceptedAt = res.acceptedTime;
      state.selectedOrder.data.actionType = res.actionType;

    },
    updateSelectedOrderStatus: (state, status) => {
      state.selectedOrder.data.orderStateEnum = status

    },
    updateSelectedOrderType: (state, type) => {
      state.selectedOrderType = type;
    },
    updateDriverData: (state, data) => {
      state.selectedOrder.data.driver = data;
    },
    updateBasketIsGroup: (state, value) => {
      state.basketCompact.data.isGroup = value
    },
    updateSettings: (state, value) => {
      state.refreshConfigurations = Object.assign(state.refreshConfigurations, value)
    },
    updateAlert: (state, value) => {
      state.alert = Object.assign(state.alert, value)
    },
    updateIsLockedProperty: (state, value) => {
      state.basket.data.isLocked = value;
      state.groupBasket.data.isLocked = value;
      state.basketCompact.data.isLocked = value;
    },
    updateHasErrorProperty: (state, value) => {
      state.lockBasketHasError = value;
    },
    updateUserBasketStateBasket: (state, value) => {
      state.userBasketStateRequest.basketUUID = value
    },
    updateRelatedRestaurants(state, relatedRestaurantss) {
      state.relatedRestaurants.count = relatedRestaurantss.count;
      state.relatedRestaurants.page = relatedRestaurantss.page;
      state.relatedRestaurants.data = relatedRestaurantss.data;

    },
    updateBasketItemModal: (state, itemModal) => {
      state.basketItemModal = itemModal;
    },
    updateBasketPaymentMethod: (state, method) => {
      state.basket.payment.method = state.basket.data.paymentType = method;
      method == state.basket.payment.paymentTypeEnum.CASH_ON_DELIVERY ?
        (state.basket.payment.cardUUID = null)
        :
        (
          (state.basket.payment.cardUUID = state.creditCards[0].uuid)
          &&
          (state.basket.ref.card ?
            (state.basket.ref.card.uuid = state.creditCards[0].uuid)
            :
            (state.basket.ref.card = { uuid: state.creditCards[0].uuid, data: null })
          )
        );
    },
    updateBasketPaymentCard: (state, cardUUID) => {
      state.basket.payment.method = state.basket.data.paymentType = state.basket.payment.paymentTypeEnum.CREDIT_CARD;
      state.basket.ref.card ?
        (state.basket.ref.card.uuid = cardUUID) :
        (state.basket.ref.card = { uuid: cardUUID, data: null })
      state.basket.payment.cardUUID = cardUUID
    },
    updateGiftingPaymentMethod: (state, method) => {
      state.promoForm.payment.method = state.promoForm.form.data.paymentTypeEnum = method;
      //state.promoForm.payment.selectedCard= null;
      //state.promoForm.form.data.cardUUID = null;
    },
    updateGiftingPaymentCard: (state, cardUUID) => {
      state.promoForm.payment.method = state.promoForm.form.data.paymentTypeEnum = state.promoForm.payment.paymentTypeEnum.CREDIT_CARD;
      const data = state.creditCards.find(card => card.uuid == cardUUID);
      state.promoForm.payment.selectedCard = data
      state.promoForm.form.data.cardUUID = cardUUID
    },
    updateTopupPaymentCard: (state, cardUUID) => {
      const data = state.creditCards.find(card => card.uuid == cardUUID);
      state.topup.payment.selectedCard = data
      state.topup.payment.cardUUID = cardUUID
    },
    newUserSignedup: (state) => {
      state.signupForm.newUser = true;
    },
    setCheckoutStep: (state, step) => {
      console.log('checkout', state.basket)
      state.basket.checkout.currentStep = step;
    },
    updateOrderSuccessVisibility: (state, value) => {
      state.basket.checkout.showOrderSuccess = value;
    },
    loginError: (state, error) => {
      state.loginForm.errors = error;
    },
    loginLoading: (state, loading) => {
      state.loginForm.loading = loading;
    },
    setShowGiftForm: (state, value) => {
      state.showGiftForm = value;
    },
    setBranchMenu: (state, value) => {
      state.branchMenus = value;
      state.commonTagUUID = value.commonTagUUID
    },
    setMenuLoading: (state, value) => {
      state.menuLoading = value;
    },
    setPromoOpenedForm: (state, value) => {
      state.promoForm.openedForm = value;
    },
    setGiftingMessageOpen(state, value) {
      state.promoForm.message = value;
    },
    setGiftingLoading(state, value) {
      state.promoForm.loading = value;
    },
    UpdateGiftingErrors(state, value) {
      state.promoForm.form.errors = value;
    },
    resetPromoForm(state) {
      state.promoForm = {
        loading: false,
        openedForm: null,
        message: false,
        currentStep: 1,
        flag: true,
        steps: [
          {
            step: 1,
            title: staticContent.gifting.steps.step1,
            optional: false
          },
          {
            step: 2,
            title: staticContent.gifting.steps.step2,
            optional: false
          },

        ],
        payment: {
          method: "CREDIT_CARD",
          paymentTypeEnum: {
            CREDIT_CARD: "CREDIT_CARD",
            CASH: "CASH_ON_DELIVERY",
          },
          selectedCard: null
        },
        form: {
          errors: null,
          loading: false,
          data: {
            paymentTypeEnum: "CREDIT_CARD",
            prefix: null,
            sms: null,
            phoneNumbers: [],
            amount: 0,
            email: null,
            phoneNumber: null,
            cardUUID: null
          }
        },
      }
    },
    signupError: (state, error) => {
      state.signupForm.errors = error;
    },
    signupLoading: (state, loading) => {
      state.signupForm.loading = loading;
    },
    resumeOrderError: (state, error) => {
      state.resumeOrder.error = error
    },
    resumeOrderLoading: (state, loading) => {
      state.resumeOrder.loading = loading
    },
    updateUserProfile: (state, profile) => {
      state.profile = profile;
      state.checkoutCycle.addressForm.fullName = profile.data.profile && profile.data.profile.name;
    },
    updateBasketRefSummary: (state, refs) => {
      state.basket.ref.restaurant = Object.assign(state.basket.ref.restaurant, refs.restaurant);
      state.basket.ref.branch = Object.assign(state.basket.ref.branch, refs.branch);
      state.basket.ref.zoneUUID = refs.zoneUUID
    },
    updateBasket: (state, basket) => {
      // state.basket.uuid = basket.uuid;
      // state.basket.data = Object.assign(state.basket.data, basket.data);
      // state.basket.ref = Object.assign(state.basket.ref, basket.ref);

      // state.basket.payment.method = state.basket.data.paymentType;
      // state.basket.payment.cardUUID = state.basket.ref.card ? state.basket.ref.card.uuid : null;
      // !state.promoRequest.code && (state.basket.ref.promo && state.basket.ref.promo.code) &&
      //   (state.promoRequest.code = state.basket.ref.promo.code)

      // let data = Object.assign(state.basket.data, basket.data);
      let data = JSON.parse(JSON.stringify(basket.data))
      let ref = Object.assign(state.basket.ref, basket.ref);
      state.basket = Object.assign(state.basket, {uuid: basket.uuid, data, ref});
      state.basket.data.basketDataExist=true;
      if (basket.data.error) {
        EventBus.$emit('basketErrors');
      }
      if (basket.ref.branch.ramadanSettings) {
        EventBus.$emit('updateDeliveryTimeFromDetails');
      }
    },
    updateIsGroupMember: (state, groupBasket) => {
      let member = (groupBasket.data.users && state.profile.uuid) ? groupBasket.data.users.find(user => (user.userUUID == state.profile.uuid)  && (user.userUUID != groupBasket.ref.adminUserUUID)) : false
      state.isGroupMember = !!member;
    },
    updatePaidWithWallet: (state, paidWithWallet) => {
      if (state.basketCompact.data.isGroup) {
        state.basket.data.memberReceipt.paidWithWallet = paidWithWallet;
      } else {
        state.basket.data.receipt.paidWithWallet = paidWithWallet;
      }
    },
    updateBasketData: (state, basketData) => {
      state.basket.data = Object.assign(state.basket.data, basketData);
      state.basket.data.basketDataExist=true;
      if (basketData.error) {
        EventBus.$emit('basketErrors');
      }
      else {
        EventBus.$emit('emptyBasketErrors');
      }

      state.unavailableItems = []
      state.basket.data.categories && state.basket.data.categories.forEach((cat, i) => {
        cat.items.forEach((item, j) => {
          if (item.error && item.error.toString().toLowerCase().includes('unavailable')) {
            state.unavailableItems.push(item.basketItemUUID)
          }
        })
      })
    },
    updateGroupBasket: (state, groupBasket) => {
      
      //**  update the array of unavailable errors      
      state.groupBasket.uuid = groupBasket.uuid;
      state.groupBasket.ref = Object.assign(state.groupBasket.ref, groupBasket.ref);;
      state.groupBasket.data = Object.assign(state.groupBasket.data, groupBasket.data);
      state.basket.data.isLocked = groupBasket.data.isLocked;
      !state.promoRequest.code && (state.groupBasket.ref.promo && state.groupBasket.ref.promo.code) &&
        (state.promoRequest.code = state.groupBasket.ref.promo.code)

      state.unavailableItems = []
      state.groupBasket.data.users && state.groupBasket.data.users.forEach((user, k) => {
        user.categories.forEach((cat, i) => {
          cat.items.forEach((item, j) => {
            if (item.error && item.error.toString().toLowerCase().includes('unavailable')) {
              state.unavailableItems.push(item.basketItemUUID)
            }
          })
        })

      })



      var itemscount = 0;
      (groupBasket.data.users)
        .forEach(function (user) {
          (user.categories)
            .forEach(function (catItem) {
              itemscount +=
                catItem.items.reduce(
                  (count, current) => count + current.quantity, 0)
            })
        });
      state.groupBasket.itemsCount = itemscount;

      if (groupBasket.data.error) {
        EventBus.$emit('basketErrors');
      }

      

    },

    updateBasketState: (state, basketState) => {
      state.basketState = basketState.state;
    },
    updateGroupError: (state, error) => {
      state.groupBasket.data.error = error;
    },
    updateBasketError: (state, error) => {
      state.basket.data.error = error;
    },
    updateBasketDataExist: (state, isExist) => {
      state.basket.data.basketDataExist = isExist;
    },
    updateToggleDeliveryTime: (state, value) => {
      state.basket.didToggleDeliveryTime = value;
    },
    createBasket: (state, payload) => {

      const exCats = payload.itemModal.flatExtraCategories;
      const selectedExCats = [];
      let loopIndex = 0;
      // handling extra categories
      for (const catUUID in payload.itemModal.flatExtraCategories) {
        if (exCats[catUUID].selectedItems && exCats[catUUID].selectedItems.length) {

          selectedExCats.push({
            extraCategoryUUID: catUUID,
            extraItemSizesUUIDs: []
          });
          exCats[catUUID].selectedItems.map(sizeUUID => {

            selectedExCats[loopIndex].extraItemSizesUUIDs.push(sizeUUID);
          });

          loopIndex++;
        }
      }

      state.createBasketRequest = {
        branchUUID: serverData.restaurantHeader.branchUUID,
        zoneUUID: payload.zoneUUID,
        restaurantUUID: serverData.restaurantUUID,
        firstItem: {
          quantity: payload.itemModal.itemData.quantity,
          itemSizeUUID: payload.itemModal.itemData.selectedSizeUUID,
          comment: payload.itemModal.itemData.comment,
          extras: selectedExCats
        }

      }
    },
    createGroupBasket: (state, payload) => {

      state.createGroupBasketRequest = {
        restaurantUUID: serverData.restaurantUUID,
        branchUUID: serverData.restaurantHeader.branchUUID,
        zoneUUID: payload.zoneUUID,
      }

    },
    setBasketCompactLoading: (state, value) => {
      state.basketCompact.loading = value;
    },
    updateBasketCompact: (state, basketCompact) => {
      state.basketCompact = Object.assign({}, state.basketCompact, basketCompact);
    },
    updateBasketCompactFromBasket: (state, basket) => {
      var itemscount = 0;
      (basket.data.categories)
        .forEach(function (catItem) {
          itemscount +=
            catItem.items.reduce(
              (count, current) => count + current.quantity, 0)
        });
      state.basketCompact.data.isGroup = false;
      state.basketCompact.data.itemCount = itemscount;
      state.basketCompact.data.totalPrice = basket.data.receipt.total;
      state.basketCompact.data.subTotal = basket.data.receipt.subTotal;
      state.basketCompact.ref.restaurantUUID = basket.ref.restaurant.uuid;
      state.basketCompact.data.restaurantName = basket.ref.restaurant.name;
      state.basketCompact.uuid = basket.uuid;
    },
    updateBasketCompactFromGroup: (state, groupBasket) => {
      var itemscount = 0;
      (groupBasket.data.users)
        .forEach(function (user) {
          (user.categories)
            .forEach(function (catItem) {
              itemscount +=
                catItem.items.reduce(
                  (count, current) => count + current.quantity, 0)
            })
        });
      state.basketCompact.data.isGroup = true;
      state.basketCompact.data.itemCount = itemscount;
      state.basketCompact.data.totalPrice = groupBasket.data.receipt.total;
      state.basketCompact.data.subTotal = groupBasket.data.receipt.subTotal;
      state.basketCompact.ref.restaurantUUID = groupBasket.ref.restaurant.uuid;
      state.basketCompact.uuid = groupBasket.uuid;
    },
    updateBasketCompactWithoutUUIDFromGroup: (state, groupBasket) => {
      var itemscount = 0;
      (groupBasket.data.users)
        .forEach(function (user) {
          (user.categories)
            .forEach(function (catItem) {
              itemscount +=
                catItem.items.reduce(
                  (count, current) => count + current.quantity, 0)
            })
        });

      state.basketCompact.data.isGroup = true;
      state.basketCompact.data.itemCount = itemscount;
      state.basketCompact.data.totalPrice = groupBasket.data.receipt.total;
      state.basketCompact.data.subTotal = groupBasket.data.receipt.subTotal;
      state.basketCompact.ref.restaurantUUID = groupBasket.ref.restaurant.uuid;
      state.basketCompact.uuid=groupBasket.uuid;
    },
    updateGroupLink: (state, groupLink) => {
      state.groupLink = groupLink;
    },
    UpdateSharedOrderUrl: (state, shareLink) => {
      state.sharedOrderLink = shareLink;
    },
    addToBasket: (state, payload) => {
      const exCats = payload.itemModal.flatExtraCategories;
      const selectedExCats = [];
      let loopIndex = 0;

      // handling extra categories
      for (const catUUID in payload.itemModal.flatExtraCategories) {
        if (exCats[catUUID].selectedItems && exCats[catUUID].selectedItems.length) {

          selectedExCats.push({
            extraCategoryUUID: catUUID,
            extraItemSizesUUIDs: []
          });
          exCats[catUUID].selectedItems.map(sizeUUID => {

            selectedExCats[loopIndex].extraItemSizesUUIDs.push(sizeUUID);

          });

          loopIndex++;
        }
      }

      state.orderItemRequest = {
        quantity: payload.itemModal.itemData.quantity,
        itemSizeUUID: payload.itemModal.itemData.selectedSizeUUID,
        comment: payload.itemModal.itemData.comment,
        extras: selectedExCats
      };
      document.documentElement.clientWidth > 1024 && !state.basket.visible && (state.basket.visible = true);
      $(".smartbanner").remove();
    },
    editBasketItem: (state, payload) => {
      const exCats = payload.flatExtraCategories;
      const selectedExCats = [];
      let loopIndex = 0;

      // handling extra categories
      for (const catUUID in payload.flatExtraCategories) {
        if (exCats[catUUID].selectedItems && exCats[catUUID].selectedItems.length) {

          selectedExCats.push({
            extraCategoryUUID: catUUID,
            extraItemSizesUUIDs: []
          });
          exCats[catUUID].selectedItems.map(sizeUUID => {

            selectedExCats[loopIndex].extraItemSizesUUIDs.push(sizeUUID);

          });

          loopIndex++;
        }
      }

      state.orderItemRequest = {
        quantity: payload.itemData.quantity,
        itemSizeUUID: payload.itemData.selectedSizeUUID,
        comment: payload.itemData.comment,
        extras: selectedExCats
      };
    },
    updateItemData: (state, itemData) => {
      state.itemAggregate = Object.assign(state.itemAggregate, itemData);
    },
    updateOrderItems(state, flattenOrderItems) {

      let itemsArray = [];
      for (let key in flattenOrderItems) {
        itemsArray = itemsArray.concat(flattenOrderItems[key]);
      }


      let itemsObj = itemsArray.reduce((itemsObj, item) => {
        itemsObj[item.itemSizeUUID] = {
          itemSizeUUID: item.itemSizeUUID,
          quantity: item.quantity,
          comment: item.comment,
          extras: item.extras
        }
        return itemsObj;
      }, {});

      state.cart.order.items = state.cart.order.items.reduce((itemsArr, item) => {
        const itemObj = itemsObj[item.itemSizeUUID];
        if (itemObj.quantity != 0) {
          itemsArr.push({
            itemSizeUUID: itemObj.itemSizeUUID,
            quantity: itemObj.quantity,
            comment: itemObj.comment,
            extras: itemObj.extras
          })
        }
        return itemsArr;
      }, []);

    },
    updateCheckoutVisibility: (state, value) => {
      state.basket.checkout.showCheckoutModal = value;
    },
    enableOrderSubmit: (state) => {
      state.basket.disableSubmit = false
    },
    setBasketLoading: (state, value) => {
      state.basket.loading = value;
    },
    setTopupLoading: (state, value) => {
      state.topup.loading = value;
    },
    setCheckoutLoadingData: (state, value) => {
      state.checkoutLoadingData = value;
    },
    setCheckoutLoadingDataError: (state, value) => {
      state.checkoutLoadingDataError = value;
    },

    updateOrderConfirmation: (state, value) => {
      state.basket.checkout.confirmation = Object.assign({}, state.basket.checkout.confirmation, value);
    },
    addPromoToBasket: (state, promo) => {
      state.basket.ref.promo = Object.assign({}, state.basket.ref.promo, promo);
    },
    UpdatePlaceOrderErrors: (state, error) => {
      error && error.response ? state.basket.checkout.placeOrderError = Object.assign({}, state.basket.checkout.placeOrderError, error.response.data) : state.basket.checkout.placeOrderError = error;
    },
    updatePromoCode: (state, value) => {
      state.promoRequest.code = value;
    },
    updatePromoErrors: (state, value) => {
      state.promoRequest.errors = value;
    },
    updateTopupErrors: (state, value) => {
      state.topup.errors = value;
    },
    // updateWallet: (state, value) => {
    //   state.basket.useWallet = value;
    // },
    updateBasketUserAddresses: (state, value) => {
      state.basketUserAddresses = Object.assign({}, state.basketUserAddresses, value);
    },
    showAutocomplete: (state) => {
      state.search.autocomplete.show = true;
    },
    hideAutocomplete: (state) => {
      state.search.autocomplete.show = false;
    },
    updateAutocomplete: (state, payload) => {
      state.search.autocomplete.data = payload.res;
      state.xTracking.autocomplete = payload.xTracking
    },
    changeBasketVisibility: (state, value) => {
      state.basket.visible = value;
    },
    changeGroupVisibility: (state, value) => {
      state.groupBasket.visible = value;
    },
    emptyBasket: (state) => {
      state.basket = Object.assign(state.basket, initBasketFn());
      state.basket.data.categories = null;
      state.basketCompact = Object.assign(state.basketCompact, initCompactBasketFn());
      state.basket.visible = false;
      state.basket.didToggleDeliveryTime = false;
    },

    emptyGroup: (state) => {
      state.groupBasket = Object.assign(state.groupBasket, initGroupBasket);
      state.groupBasket.data.users = null;
      state.basketCompact = Object.assign(state.basketCompact, initCompactBasketFn());
      state.groupBasket.visible = false;
    },
    updateUserCreditCards: (state, creditCards) => {
      state.creditCards = creditCards;
    },
    updateBasketItemErrors: (state, basketCategories: BasketCategory[]) => {
      let basketItemErrors = basketCategories.reduce((categoriesItemErrors: MapEnumToText, category) => {
        let categoryItemsErrors = category.items.reduce((basketItemErrors: MapEnumToText, item) => {
          item.error && (basketItemErrors[item.error] = state.basket.errorsEnumToText[item.error]);
          return basketItemErrors;
        }, {});
        return Object.assign({}, categoriesItemErrors, categoryItemsErrors)
      }, {});

      state.basket.basketItemErrors = basketItemErrors;
    },
    updateGroupBasketItemErrors: (state, groupUsers: GroupBasketUser[]) => {
      let basketItemErrors = groupUsers.reduce((usersItemErrors: MapEnumToText, basketUser) => {
        let userItemsErrors = basketUser.categories.reduce((categoriesItemErrors: MapEnumToText, category) => {
          let categoryItemsErrors = category.items.reduce((basketItemErrors: MapEnumToText, item) => {
            item.error && (basketItemErrors[item.error] = state.basket.errorsEnumToText[item.error]);
            return basketItemErrors;
          }, {});
          return Object.assign({}, categoriesItemErrors, categoryItemsErrors)
        }, {});
        return Object.assign({}, usersItemErrors, userItemsErrors)
      }, {});

      state.basket.basketItemErrors = basketItemErrors;

    },
    updateAreaZoneVisibility: (state, value) => {
      state.basket.showAreaZone = value;
    },
    updateCurrentOrders: (state, data) => {
      state.currentOrders.count = data.count
      state.currentOrders.page = data.page
      state.currentOrders.data.push.apply(state.currentOrders.data, data.data);

      // data.data.map(el=>{
      //   state.currentOrders.data.push(el);

      // })
    },
    updateCurrentOrdersLoader(state, val) {
      state.currentOrdersLoader = val
    },
    updatePreviousOrdersLoader(state, val) {
      state.previousOrdersLoader = val
    },
    updatePreviousOrders: (state, data) => {
      state.previousOrders.count = data.count
      state.previousOrders.page = data.page
      state.previousOrders.data.push.apply(state.previousOrders.data, data.data);

      // data.data.map(el=>{
      //   state.previousOrders.data.push(el);

      // })
    },
    updateSelectedOrder: (state, data) => {
      state.selectedOrder = Object.assign(state.selectedOrder, data);
    },
    updateSelectedTrip: (state, data) => {
      state.selectedTrip = { ...state.selectedTrip, ...data };
    },
    updateTastyOffers: (state, tastyOffers) => {
      state.tastyOffers = Object.assign(state.tastyOffers, tastyOffers);
      EventBus.$emit('destroyOffersSlider');
    },
    updateVerificationCardError: (state, data) => {
      state.cardVerification.error = data.error;
      state.cardVerification.errorCode = data.code
    },
    updatePromoBanner: (state, data) => {
      state.promoBanner = data;
    },
    updateCardRequest: (state, data) => {
      state.cardRequest = { ...state.cardRequest, ...data };
    },
    updateCardSignatureRequest: (state, signature) => {
      state.cardRequest.signature = signature
    },
    addCardError: (state, error) => {
      state.cardRequest.error = error ? true : false;
      state.cardRequest.errorMessage = error;
    },
    addCardLoading: (state, loading) => {
      state.cardRequest.loading = loading
    },
    getCardsLoading: (state, loading) => {
      state.cardsLoading = loading
    },
    emptyCardRequest: (state) => {
      state.cardRequest = {
        loading: false,
        error: false,
        errorMessage: '',
        merchant_reference: "",
        signature: '',
        token_name: '',
        uuid: '',
        fort_id: '',
        expiry_date: '',
        payment_option: '',
        card_number: '',
      }
    },
    setPromoFormStep: (state, step) => {
      state.promoForm.currentStep = step;
    },
    updatePromoFormData: (state, data) => {
      state.promoForm.form.data = { ...state.promoForm.form.data, ...data };
      state.promoForm.flag = true;
    },
    updateOpenedPromoForm: (state, value) => {
      state.promoForm.openedForm = value;
    }
  },

  actions: {
    GET_PROMO_BANNER({ commit, state }, noOfOrders) {
      return axios({
        headers: headers,
        url: servicesURL.profile.promoBanner(getCookie(cookies.userArea) || null, noOfOrders),
        method: 'GET'
      }).then(res => {
        commit("updatePromoBanner", res.data);
      }).catch(error => {
        commit("updatePromoBanner", null);
       })
    },
    GET_RELATED_RESTAURANTS({ commit, state }, commonTagUUID) {
      return axios({
        headers: headers,
        url: servicesURL.restaurant.getRelatedRestaurants(commonTagUUID),
        method: 'GET'
      }).then(res => {
        commit("updateRelatedRestaurants", res.data);
      }).catch(error => {
        console.log('error: ', error);
      })
    },
    UNLOCK_BASKET({ commit, state }, groupBasketuuid) {
      let endPoint = servicesURL.basket.unlock(groupBasketuuid);
      commit("updateHasErrorProperty", false);
      commit("setBasketLoading", BasketLoadersEnum.unlock);

      return axios({
        headers: headers,
        url: endPoint,
        method: 'PUT'
      }).then(res => {
        commit("updateIsLockedProperty", false);
        commit("updateHasErrorProperty", false);
        commit("setBasketLoading", null);
        pushAnalyticsEvent(
          analyticsEvents.ordering.category,
          analyticsEvents.ordering.events.unlockGroup,
          analyticsEvents.ordering.labels.basketUUID(state.groupBasket.uuid)
        )
      }).catch(error => {
        console.log('error: ', error);
        commit("updateHasErrorProperty", true);
      })
    },
    LEAVE_BASKET({ commit, state, dispatch }, groupBasketuuid) {
      let endPoint = servicesURL.basket.leave(groupBasketuuid);
      commit("setBasketLoading", BasketLoadersEnum.removeAll);

      return axios({
        headers: headers,
        url: endPoint,
        method: 'PUT'
      }).then(res => {
        commit('emptyBasket');
        commit('emptyGroup');
        dispatch("getUserProfileData", false);
        commit('updateBasketState', { state: "NO_BASKET" });
        commit("setBasketLoading", null);
        pushAnalyticsEvent(
          analyticsEvents.ordering.category,
          analyticsEvents.ordering.events.leaveGroup,
          analyticsEvents.ordering.labels.basketUUID(state.groupBasket.uuid)
        )
      }).catch(error => {
        commit("setBasketLoading", null);
      })
    },

    UPDATE_BASKET_PAYMENT_METHOD({ commit, state }, paymentRequest) {
      return axios({
        headers: headers,
        url: servicesURL.basket.payment,
        method: 'PUT',
        data: JSON.stringify({
          payment: paymentRequest.method,
          cardUUID: paymentRequest.carduuid
        })
      }).then(res => {
        commit('updateBasket', res.data);
        res.data.data.categories && commit('updateBasketItemErrors', res.data.data.categories);
      }).catch(error => {
        console.log('error: ', error);
      })
    },
    GET_USER_CREDIT_CARDS({ commit, state }) {
      commit('getCardsLoading', true);
      axios({
        headers: headers,
        url: servicesURL.creditCards.getCards,
        method: 'GET'
      }).then(res => {
        commit('getCardsLoading', false);
        commit('updateUserCreditCards', res.data.data);
        state.isGroupMember && commit('updateTopupPaymentCard', res.data.data[0].uuid)
        state.promoForm.form.data.paymentTypeEnum == state.promoForm.payment.paymentTypeEnum.CREDIT_CARD && commit('updateGiftingPaymentCard', res.data.data[0].uuid)
      }).catch(error => {
        commit('getCardsLoading', false);
        console.log('error: ', error);
      })
    },
    TRUST_USER_CREDIT_CARDS({ commit, dispatch }, data) {
      headers['Device-ID'] = deviceID;
      axios({
        method: "POST",
        url: servicesURL.creditCards.trustCard(data.uuid),
        headers: headers,
        data: JSON.stringify(data.date)
      })
        .then(res => {
          commit('updateVerificationCardError', { error: false, code: null })
          EventBus.$emit('modalToggler', ['credit-card-verification', 'hide']);


          dispatch(`PLACE_ORDER`, [])
          EventBus.$emit('disablePlaceorderButton');
        })
        .catch(error => {
          console.log('error: ', error);
          commit('updateVerificationCardError', { error: true, code: error.response.data.error })
        })
    },
    requestAutocomplete({ commit, state }, params) {
      state.search.autocomplete.ajaxRequest = axios({
        method: "GET",
        url: servicesURL.restaurant.autocomplete(params),
        headers: headers
      }).then(res => {
        const payload = {
          res: res.data.results,
          xTracking: res.request.getResponseHeader(cookies.xTracking)
        }
        commit('updateAutocomplete', payload);
        commit('showAutocomplete');
      }).catch(error => {
        console.log('error: ', error);
      });
    },
    hideAutocomplete({ commit }) {
      setTimeout(() => {
        commit('hideAutocomplete');
      }, 200)
    },
    login({ commit, dispatch, state }, payload: payload<LoginFormRequest>) {
      commit('loginError', null);
      commit('loginLoading', true);

      return axios({
        headers: headers,
        url: servicesURL.auth.post,
        method: 'POST',
        data: JSON.stringify(payload.data.body),
      }).then(res => {
        //cookie to expire in 30 days
        setCookie("Authorization", res.data.token, '/');
        headers['Authorization'] = "Bearer " + res.data.token
        pushAnalyticsEvent(
          analyticsEvents.loging.category,
          analyticsEvents.loging.events.email,
          analyticsEvents.loging.labels.email(payload.data.body.email)
        );
        window['gtag']('event', 'login', { method: 'Email' });
        window['gtag']('set', 'user_properties', {
          Guest: 'No',
        });
        if (!payload.data.reload) {
          dispatch('getUserProfileData', true);
          EventBus.$emit('getNotificationData');
          serverData.restaurantUUID && dispatch('GET_BASKET_STATE');

        } else {
          dispatch('getUserProfileData', false);
          EventBus.$emit('getNotificationData');
          serverData.restaurantUUID && dispatch('GET_BASKET_STATE');
        }
        state.promoForm.openedForm && dispatch('PREP_ADD_CREDIT_CARD')
        commit('loginLoading', false);
      }).catch(error => {
        commit('loginLoading', false);
        error.response.data && commit('loginError', staticContent.login.loginError);
      })
    },
    resetPassword({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios({
          method: "POST",
          url: servicesURL.user.forgetPassword(payload.email),
          headers: headers,
        })
          .then(res => resolve(res))
          .catch(error => reject(error));
      })
    },
    // authentication login revamp
    authenticateUserAction({ commit, dispatch }, payload: payload<LoginFormRequest>,) {


      commit('loginError', null);
      commit('loginLoading', true);
      return axios({
        headers: headers,
        url: servicesURL.user.login,
        method: 'POST',
        data: {
          email: payload.data.body.email,
          password: payload.data.body.password
        }
      }).then(res => {
         setCookie("Authorization", res.data.accessToken, '/');
        setCookie("webRefreshToken", res.data.refreshToken, '/');

        headers['Authorization'] = "Bearer " + res.data.accessToken
        dispatch('GET_USER_CREDIT_CARDS');
        pushAnalyticsEvent(
          analyticsEvents.loging.category,
          analyticsEvents.loging.events.email,
          analyticsEvents.loging.labels.email(payload.data.body.email)
        );
        window['gtag']('event', 'login', { method: 'Email' });
        window['gtag']('set', 'user_properties', {
          Guest: 'No'
        });
        if (!payload.data.reload || payload.data.reOrder) {
          dispatch('getUserProfileData', [true, payload.data.reOrder]);
          EventBus.$emit('getNotificationData');
          serverData.restaurantUUID && dispatch('GET_BASKET_STATE');

        }

        else {
          dispatch('getUserProfileData', false);
          EventBus.$emit('getNotificationData');
          serverData.restaurantUUID && dispatch('GET_BASKET_STATE');
        }

        commit('loginLoading', false);
        dispatch("PREP_ADD_CREDIT_CARD");
      }).catch((error) => {
        commit('loginLoading', false);
        (error.response && error.response.data) && commit('loginError', staticContent.login.loginError);
      });
    },
    signup({ commit, dispatch, state }, payload: payload<SignupFormRequest>) {
      commit('signupError', null);
      commit('signupLoading', true);

      return axios({
        headers: headers,
        url: servicesURL.user.register,
        method: 'POST',
        data: JSON.stringify(payload.data.body)
      }).then(res => {
        commit('newUserSignedup');
        commit('setShowGiftForm', true);
        setCookie("Authorization", res.data.accessToken, '/');
        setCookie("webRefreshToken", res.data.refreshToken, '/');

        headers['Authorization'] = "Bearer " + res.data.accessToken
        pushAnalyticsEvent(
          analyticsEvents.loging.category,
          analyticsEvents.loging.events.create,
          analyticsEvents.loging.labels.email(payload.data.body.email)
        );

        window['gtag']('event', 'sign_up', { method: 'Email' });
        window['gtag']('set', 'user_properties', {
          Guest: 'No',
          User_Type: 'Newly Registered',
          First_Order: 'Yes'
        });
        if (!payload.data.reload || payload.data.reOrder) {
          dispatch('getUserProfileData', [true, payload.data.reOrder]);
          EventBus.$emit('getNotificationData');

        } else {
          dispatch('getUserProfileData', false);
          EventBus.$emit('getNotificationData');
          serverData.restaurantUUID && dispatch('GET_BASKET_STATE');
        }

        state.promoForm.openedForm && dispatch('PREP_ADD_CREDIT_CARD');
        commit('signupLoading', false);
      }).catch(error => {
        commit('signupLoading', false);
        // console.log('error.response.data', error.response);
        error.response.data && commit('signupError', error.response.data.message);
      })
    },
    googleLogin({ commit, dispatch }, [payload, reOrder]) {
      console.log('reOrder From google', reOrder)
      commit('loginError', null);
      commit('loginLoading', true);
      axios({
        method: "POST",
        url: servicesURL.google.login,
        data: JSON.stringify({
          name: payload.name,
          email: payload.email,
          socialId: payload.id,
          socialToken: payload.token
        }),
        headers
      })
        .then(res => {
          setCookie(cookies.auth, res.data.accessToken, '/');
          setCookie('webRefreshToken', res.data.refreshToken, '/');
          headers['Authorization'] = "Bearer " + res.data.accessToken

          dispatch('getUserProfileData', [true, reOrder]);
          serverData.restaurantHeader && dispatch('GET_BASKET_STATE');
          EventBus.$emit('getNotificationData');

          commit('loginLoading', false);
          dispatch("PREP_ADD_CREDIT_CARD");
        })
        .catch((error) => {
          console.log('error', error);
          commit('loginLoading', false);
        });
    },
    getUserProfileData({ commit, dispatch, state }, [isCreateBasket, isReOrder = false]) {
      console.log('isReOrder', isReOrder)
      headers[cookies.auth] = "Bearer " + getCookie(cookies.auth);
      axios({
        method: "GET",
        url: servicesURL.profile.userProfile,
        headers
      })
        .then(res => {
          //  window['webengage'].user.login(res.data.uuid);
          //  window['webengage'].user.setAttribute('isGuest', res.data.data.profile?false:true);
          commit('updateUserProfile', res.data);
          dispatch('GET_PROMO_BANNER', (res.data.data.totalOrderCount - (res.data.data.rejectedOrderCount + res.data.data.canceledOrderCount)));
          let userCreatedDate = new Date(state.profile.data.createdAt);
          let currentDate = new Date();
          window['gtag']('set', 'user_properties', {
            First_Order: state.profile.data.totalOrderCount > 0 ? "No" : "Yes",
            User_Type: state.profile.data.profile.name ? (userCreatedDate.getFullYear() >= (currentDate.getFullYear()) && userCreatedDate.getMonth() >= (currentDate.getMonth()) ? "Newly Registered" : "Existing Registered") : "Guest",
            Fulfilled_Order_Count: state.profile.data.totalOrderCount - (state.profile.data.rejectedOrderCount + state.profile.data.canceledOrderCount)

          });
          commit('updateIsGroupMember', state.groupBasket)
          if (res.data.data.hasDraft)
            dispatch('GET_USER_BASKET_COMPACT').then(
              reason => {
                if (isCreateBasket) {
                  isReOrder ? EventBus.$emit('handleReorderFromShare') : EventBus.$emit('showAreaZone')
                }
              }
            );
          else {
            if (isCreateBasket && isReOrder) {
              EventBus.$emit('handleReorderFromShare')
            }
            else if (isCreateBasket && !isReOrder) {
              EventBus.$emit('showAreaZone')
            }
          }

        })
        .catch(error => {
          console.log('error: ', error);
        });
    },
    GET_SETTINGS({ commit }) {
      axios({
        method: "GET",
        url: servicesURL.settings,
        headers: headers
      })
        .then(res => {
          commit('updateSettings', res.data.web);
        })
        .catch(error => {
          console.log("error", error)
        });
    },
    GET_USER_BASKET({ commit, state }) {
      commit("setBasketLoading", BasketLoadersEnum.getItems);
      return new Promise(function (resolve, reject) {
        axios({
          method: "GET",
          url: servicesURL.basket.details,
          headers: headers
        })
          .then(res => {
            commit('updateBasket', res.data);
            commit("setBasketLoading", null);
            res.data.data.categories && commit('updateBasketItemErrors', res.data.data.categories);
            if (state.basketCompact && state.basketCompact.data.isGroup && ((state.profile && state.profile.uuid) == state.groupBasket.ref.adminUserUUID)) {
              commit("updateIsLockedProperty", true);
            }
            resolve(res)

          })
          .catch(error => {
            reject(error)
          })
      })
    },
    UPDATE_DELIVERY_PROMPT_TOGGLE({ commit }, value) {
      commit('updateToggleDeliveryTime', value);
    },
    SET_RAMADAN_ORDER_TYPE({ commit, state }, type) {
      let data = {
        deliveryTime: type
      }

      return axios({
        method: "PUT",
        url: servicesURL.basket.deliveryTime,
        headers,
        data: JSON.stringify(data)
      })
        .then(res => {
          commit('updateBasket', res.data);
          res.data.data.categories && commit('updateBasketItemErrors', res.data.data.categories);
        })
        .catch(error => {
          console.log('error: ', error);
        });
    },
    async GET_USER_BASKET_SUMMARY({ commit }) {
      commit("setBasketLoading", BasketLoadersEnum.getItems);
      commit('setBasketCompactLoading', true);
      await axios({
        method: "GET",
        url: servicesURL.basket.summary,
        headers: headers
      })
        .then(res => {
          commit('updateBasketData', res.data.data);
          res.data.data.categories && commit('updateBasketItemErrors', res.data.data.categories);
          commit('updateBasketRefSummary', res.data.ref);
          commit('updateBasketCompactFromBasket', res.data);
          commit("setBasketLoading", null);
          commit('setBasketCompactLoading', false);
          commit('updateBasketDataExist', true);
        })
        .catch(error => {
          commit("setBasketLoading", null);
          commit('setBasketCompactLoading', false);
          commit('updateBasketError', error.response.data.error);
          commit('updateBasketDataExist', false);
          EventBus.$emit('basketErrors');
          console.log('error: ', error);
        })
    },
    ADD_ITEM_TO_BASKET({ commit, state }, retryValues) {
      commit('setBasketCompactLoading', true);
      commit("setBasketLoading", BasketLoadersEnum.addItem);
      return axios({
        method: "POST",
        url: servicesURL.basket.item,
        headers: headers,
        data: retryValues == undefined ? JSON.stringify(state.orderItemRequest) : JSON.stringify(retryValues)
      })
        .then(res => {
          commit('updateBasketData', res.data.data);
          res.data.data.categories && commit('updateBasketItemErrors', res.data.data.categories);
          commit('updateBasketRefSummary', res.data.ref);
          commit('updateBasketCompactFromBasket', res.data);
          commit("setBasketLoading", null);
          commit('setBasketCompactLoading', false);
          EventBus.$emit("addItemSuccess", "No");
          window['gtag']('event', 'add_to_cart', {
            "items": [
              {
                "id": state.orderItemRequest.itemSizeUUID,
                "quantity": state.orderItemRequest.quantity
              }
            ]
          });
          pushAnalyticsEvent(
            analyticsEvents.ordering.category,
            analyticsEvents.ordering.events.addItem,
            analyticsEvents.ordering.labels.basketUUID(state.basket.uuid)
          )
        })
        .catch(error => {
          pushAnalyticsEvent(
            analyticsEvents.ordering.category,
            analyticsEvents.ordering.events.addItemError,
            analyticsEvents.ordering.labels.basketUUID(state.basket.uuid)
          )
          commit("setBasketLoading", null);
          commit('setBasketCompactLoading', false);
          console.log('error: ', error);
        })
    },
    ADD_ITEM_TO_GROUP_BASKET({ commit, state }, addItemRequest) {
      commit('setBasketCompactLoading', true);
      commit("setBasketLoading", BasketLoadersEnum.addItem);

      return axios({
        method: "POST",
        url: servicesURL.basket.group.item(addItemRequest.basketUUID),
        headers: headers,
        data: addItemRequest.OrderItemRequest == undefined ? JSON.stringify(state.orderItemRequest) : JSON.stringify(addItemRequest.OrderItemRequest)
      })
        .then(res => {
          res.data.data.users && commit('updateGroupBasketItemErrors', res.data.data.users);
          commit('updateGroupBasket', res.data);
          commit('updateIsGroupMember', res.data);
          commit('updateBasketCompactFromGroup', res.data);
          commit("setBasketLoading", null);
          commit('setBasketCompactLoading', false);
          EventBus.$emit("addItemSuccess", "No");
          window['gtag']('event', 'add_to_cart', {
            "items": [
              {
                "id": addItemRequest.OrderItemRequest == undefined ? state.orderItemRequest.itemSizeUUID : addItemRequest.OrderItemRequest.itemSizeUUID,
                "quantity": addItemRequest.OrderItemRequest == undefined ? state.orderItemRequest.quantity : addItemRequest.OrderItemRequest.quantity
              }
            ]
          });
          pushAnalyticsEvent(
            analyticsEvents.ordering.category,
            analyticsEvents.ordering.events.addItem,
            analyticsEvents.ordering.labels.basketUUID(state.groupBasket.uuid)
          )
        })
        .catch(error => {
          pushAnalyticsEvent(
            analyticsEvents.ordering.category,
            analyticsEvents.ordering.events.addItemError,
            analyticsEvents.ordering.labels.basketUUID(state.groupBasket.uuid)
          )
          commit("setBasketLoading", null);
          commit('setBasketCompactLoading', false);
          console.log('error: ', error);
        })
    },
    JOIN_TO_GROUP_BASKET({ commit, state }, addItemRequest) {
      commit('setBasketCompactLoading', true);
      commit("setBasketLoading", BasketLoadersEnum.addItem);

      return axios({
        method: "PUT",
        url: servicesURL.basket.group.join(addItemRequest.basketUUID),
        headers: headers,
        data: addItemRequest.OrderItemRequest == undefined ? JSON.stringify({
          username: addItemRequest.userName,
          firstItem: state.orderItemRequest
        }) : JSON.stringify({
          username: addItemRequest.userName,
          firstItem: addItemRequest.OrderItemRequest,
          useWallet: true
        })
      })
        .then(res => {
          res.data.data.users && commit('updateGroupBasketItemErrors', res.data.data.users);
          commit('updateGroupBasket', res.data);
          commit('updateIsGroupMember', res.data);
          commit('updateBasketCompactFromGroup', res.data);
          commit('updateBasketState', { state: "MEMBER_IN_THIS_GROUP" });
          commit("setBasketLoading", null);
          commit('setBasketCompactLoading', false);
          EventBus.$emit("addItemSuccess", "No");
          pushAnalyticsEvent(
            analyticsEvents.ordering.category,
            analyticsEvents.ordering.events.joinGroup,
            analyticsEvents.ordering.labels.basketUUID(state.groupBasket.uuid)
          )
        })
        .catch(error => {
          commit("setBasketLoading", null);
          commit('setBasketCompactLoading', false);
          pushAnalyticsEvent(
            analyticsEvents.ordering.category,
            analyticsEvents.ordering.events.joinGroupError,
            analyticsEvents.ordering.labels.basketUUID(state.groupBasket.uuid)
          )
          console.log('error: ', error);
        })
    },
    GET_GROUP_LINK({ commit, state }, basketUUID) {
      return axios({
        method: "GET",
        url: servicesURL.basket.group.link(basketUUID),
        headers
      })
        .then(res => {
          commit('updateGroupLink', res.data);
          pushAnalyticsEvent(
            analyticsEvents.ordering.category,
            analyticsEvents.ordering.events.shareGroup,
            analyticsEvents.ordering.labels.basketUUID(state.groupBasket.uuid)
          )
        })
        .catch(error => {
          console.log('error: ', error);
        })
    },
    GET_ITEM_DETAILS({ commit, state }, [branchShortCode, basketItemUUID]) {
      return axios({
        method: "GET",
        url: servicesURL.restaurant.item.getDetails(branchShortCode ,basketItemUUID),
        headers
      })
        .then(res => {
          commit('updateItemData', res.data);
        })
        .catch(error => {
          console.log('error: ', error);
        });
    },
    EDIT_BASKET_ITEM({ commit, state }, basketItemUUID) {

      commit('setBasketCompactLoading', true);
      commit("setBasketLoading", BasketLoadersEnum.editItem);
      return axios({
        method: "PUT",
        url: servicesURL.basket.edit(basketItemUUID),
        headers,
        data: JSON.stringify(state.orderItemRequest)
      })
        .then(res => {
          commit('updateBasketData', res.data.data);
          res.data.data.categories && commit('updateBasketItemErrors', res.data.data.categories);
          commit('updateBasketRefSummary', res.data.ref);
          commit('updateBasketCompactFromBasket', res.data);
          commit("setBasketLoading", null);
          commit('setBasketCompactLoading', false);
          pushAnalyticsEvent(
            analyticsEvents.ordering.category,
            analyticsEvents.ordering.events.editItem,
            analyticsEvents.ordering.labels.basketUUID(state.basket.uuid)
          );
        })
        .catch(error => {
          commit("setBasketLoading", null);
          commit('setBasketCompactLoading', false);
          console.log('error: ', error);
        });
    },
    EDIT_GROUP_BASKET_ITEM({ commit, state }, basketItemUUID) {

      commit('setBasketCompactLoading', true);
      commit("setBasketLoading", BasketLoadersEnum.editItem);
      return axios({
        method: "PUT",
        url: servicesURL.basket.group.updateItem(state.groupBasket.uuid, basketItemUUID),
        headers,
        data: JSON.stringify(state.orderItemRequest)
      })
        .then(res => {
          res.data.data.users && commit('updateGroupBasketItemErrors', res.data.data.users);
          commit('updateGroupBasket', res.data);
          commit('updateIsGroupMember', res.data);
          commit('updateBasketCompactFromGroup', res.data);
          commit("setBasketLoading", null);
          commit('setBasketCompactLoading', false);

          pushAnalyticsEvent(
            analyticsEvents.ordering.category,
            analyticsEvents.ordering.events.editItem,
            analyticsEvents.ordering.labels.basketUUID(state.groupBasket.uuid)
          );
        })
        .catch(error => {
          commit("setBasketLoading", null);
          commit('setBasketCompactLoading', false);
          console.log('error: ', error);
        });
    },
    REMOVE_ITEM_FROM_GROUP_BASKET({ commit, state }, basketItemUUID) {

      commit('setBasketCompactLoading', true);
      commit("setBasketLoading", BasketLoadersEnum.removeItem);

      return axios({
        method: "DELETE",
        url: servicesURL.basket.group.updateItem(state.groupBasket.uuid, basketItemUUID),
        headers
      })
        .then(res => {
          res.data.data.users && commit('updateGroupBasketItemErrors', res.data.data.users);
          commit('updateGroupBasket', res.data);
          commit('updateIsGroupMember', res.data);
          commit('updateBasketCompactFromGroup', res.data);
          commit("setBasketLoading", null);
          commit('setBasketCompactLoading', false);
          window['gtag']('event', 'remove_from_cart', {
            "items": [
              { "id": basketItemUUID }
            ]
          });
          pushAnalyticsEvent(
            analyticsEvents.ordering.category,
            analyticsEvents.ordering.events.removeItem,
            analyticsEvents.ordering.labels.basketUUID(state.groupBasket.uuid)
          )
        })
        .catch(error => {
          commit("setBasketLoading", null);
          commit('setBasketCompactLoading', false);
          EventBus.$emit('handleGroupError', error.response.data.error);
          console.log('error: ', error);
        });
    },
    CREATE_BASKET({ commit, state, dispatch }, retryValues) {

      commit('setBasketCompactLoading', true);

      return axios({
        method: "POST",
        url: servicesURL.basket.create,
        headers,
        data: retryValues == undefined ? JSON.stringify(state.createBasketRequest) : JSON.stringify(retryValues)
      })
        .then(res => {
          commit('updateBasketData', res.data.data);
          res.data.data.categories && commit('updateBasketItemErrors', res.data.data.categories);
          commit('updateBasketRefSummary', res.data.ref);
          commit('updateBasketCompactFromBasket', res.data);
          state.promoRequest.code && dispatch('ADD_PROMO_TO_BASKET');
          commit("setBasketLoading", null);
          commit('setBasketCompactLoading', false);
          EventBus.$emit("addItemSuccess", state.basket.showAreaZone ? "Yes" : "No");
          
          pushGoogleAnalytics4Event(state.profile, GA4Events.action.viewBasket, {
            "Restaurant_Name": res.data.ref.restaurant.name,
            "Restaurant_UUID": res.data.ref.restaurant.uuid
          });
        })
        .catch(error => {
          pushAnalyticsEvent(
            analyticsEvents.ordering.category,
            analyticsEvents.ordering.events.createBasketError,
            analyticsEvents.ordering.labels.firstOrder(!(state.profile.data.totalOrderCount > 0))
          )
          commit("setBasketLoading", null);
          commit('setBasketCompactLoading', false);
          console.log('error: ', error);
        });
    },
    CREATE_GROUP_BASKET({ commit, state, dispatch }, retryValues) {
      commit("setBasketLoading", BasketLoadersEnum.getItems);
      commit('setBasketCompactLoading', true);
      return axios({
        method: 'POST',
        url: servicesURL.basket.group.start,
        headers: headers,
        data: retryValues == undefined ? JSON.stringify(state.createGroupBasketRequest) : JSON.stringify(retryValues)
      })
        .then(res => {
          res.data.data.users && commit('updateGroupBasketItemErrors', res.data.data.users);
          commit('updateGroupBasket', res.data);
          commit('updateIsGroupMember', res.data);
          commit('updateBasketState', { state: "MEMBER_IN_THIS_GROUP" });
          commit('updateBasketCompactFromGroup', res.data);
          EventBus.$emit('changeGroupVisibility', true);
          state.promoRequest.code && dispatch('ADD_PROMO_TO_BASKET');
          commit("setBasketLoading", null);
          commit('setBasketCompactLoading', false);
          pushAnalyticsEvent(
            analyticsEvents.ordering.category,
            analyticsEvents.ordering.events.createGroup,
            analyticsEvents.ordering.labels.firstOrder(!(state.profile.data.totalOrderCount > 0))
          );
        })
        .catch(error => {
          console.log('error: ', error);
          pushAnalyticsEvent(
            analyticsEvents.ordering.category,
            analyticsEvents.ordering.events.startGroupError,
            analyticsEvents.ordering.labels.firstOrder(!(state.profile.data.totalOrderCount > 0))
          )
          commit("setBasketLoading", null);
          commit('setBasketCompactLoading', false);
        })
    },
    GET_BASKET_STATE({ commit, state }) {
      return new Promise((resolve, reject) => {
        axios({
          headers: headers,
          url: servicesURL.basket.state,
          method: 'POST',
          data: JSON.stringify(state.userBasketStateRequest)

        }).then(res => {
          commit('updateBasketState', res.data);
          resolve(res.data);
        }).catch(error => {
          console.log('error: ', error);
          reject(error.response.data)
        })
      })
    },
    GET_USER_BASKET_COMPACT({ commit }, displayError = true) {
      commit('setBasketCompactLoading', true);
      return axios({
        headers: headers,
        url: servicesURL.basket.compact,
        method: 'GET'
      }).then(res => {
        commit('updateBasketCompact', res.data);
        commit('setBasketCompactLoading', false);
      }).catch(error => {
        console.log('error: ', error);
        commit('setBasketCompactLoading', false);
        if (displayError) {
          EventBus.$emit('handleGroupError', error.response.data.error);
        }
        else {
          EventBus.$emit('handleLogOut');
        }
      })
    },
    CONVERT_USER_BASKET_TO_GROUP({ commit }) {

      commit("setBasketLoading", BasketLoadersEnum.getItems);
      return new Promise((resolve, reject) => {
        axios({
          headers: headers,
          url: servicesURL.basket.group.convert,
          method: 'PUT'
        }).then(res => {
          commit('changeBasketVisibility', false);
          EventBus.$emit('changeGroupVisibility', true);
          commit('updateGroupBasket', res.data);
          commit('updateIsGroupMember', res.data);
          res.data.data.users && commit('updateGroupBasketItemErrors', res.data.data.users);
          commit('updateBasketCompactFromGroup', res.data);
          commit('updateBasketState', { state: "MEMBER_IN_THIS_GROUP" });
          commit("setBasketLoading", null);
          commit('setBasketCompactLoading', false);
          pushAnalyticsEvent(
            analyticsEvents.ordering.category,
            analyticsEvents.ordering.events.convertToGroup);
          resolve();
        }).catch(error => {
          console.log('error: ', error);
          commit("setBasketLoading", null);
          commit('setBasketCompactLoading', false);
          reject();
        })
      })
    },
    GET_GROUP_BASKET_SUMMARY({ commit }, basketUUID) {
      commit("setCheckoutLoadingData", BasketLoadersEnum.checkoutLoadingData);
      commit("setCheckoutLoadingDataError", false);

      return axios({
        headers: headers,
        url: servicesURL.basket.group.summary(basketUUID),
        method: 'GET'
      }).then(res => {
        commit('updateGroupBasket', res.data);
        commit('updateIsGroupMember', res.data);
        commit('updateBasketCompactWithoutUUIDFromGroup', res.data);
        res.data.data.users && commit('updateGroupBasketItemErrors', res.data.data.users);
        commit("setBasketLoading", null);
        commit("setCheckoutLoadingData", null);
        commit("setCheckoutLoadingDataError", false);
        commit('updateBasketDataExist', true);
      }).catch(error => {
        console.log('error: ', error);
        commit("setCheckoutLoadingData", null);
        commit("setCheckoutLoadingDataError", true);
        commit("updateGroupError", error.response.data.error)
        commit('updateBasketDataExist', false);
        EventBus.$emit('handleGroupError', error.response.data.error);
      })
    },
    REMOVE_ITEM_FROM_BASKET({ commit, state, dispatch }, basketItemUUID) {
      commit('setBasketCompactLoading', true);
      commit("setBasketLoading", BasketLoadersEnum.removeItem);
      let endPoint = servicesURL.basket.removeItem(basketItemUUID);
      let isLastItem = (
        state.basket.data.categories.length == 1
        && state.basket.data.categories[0].items.length == 1
      );

      isLastItem && dispatch('REMOVE_ALL_ITEMS_FROM_BASKET');

      return !isLastItem && axios({
        headers: headers,
        url: endPoint,
        method: 'DELETE'
      }).then(res => {
        commit('updateBasketData', res.data.data);
        res.data.data.categories && commit('updateBasketItemErrors', res.data.data.categories);
        commit('updateBasketRefSummary', res.data.ref);
        commit('updateBasketCompactFromBasket', res.data);
        commit("setBasketLoading", null);
        commit('setBasketCompactLoading', false);
        window['gtag']('event', 'remove_from_cart', {
          "items": [
            { "id": basketItemUUID }
          ]
        });
        pushAnalyticsEvent(
          analyticsEvents.ordering.category,
          analyticsEvents.ordering.events.removeItem,
          analyticsEvents.ordering.labels.basketUUID(state.basket.uuid)
        )
      }).catch(error => {
        console.log('error: ', error);
        commit("setBasketLoading", null);
        commit('setBasketCompactLoading', false);
      })

    },
    REMOVE_BULK_FROM_BASKET({ commit, state, dispatch }, DeleteBasketItemBulk) {
      commit('setBasketCompactLoading', true);
      let endPoint = servicesURL.basket.removeBulk;
      let obj = {
        "items": DeleteBasketItemBulk
      }

      return axios({
        headers: headers,
        url: endPoint,
        method: 'DELETE',
        data: JSON.stringify(obj)
      }).then(res => {
        pushAnalyticsEvent(
          analyticsEvents.ordering.category,
          analyticsEvents.ordering.events.removeErroredItems,
          analyticsEvents.ordering.labels.basketUUID(state.basket.uuid)
        )
      }).catch(error => {
        console.log('error: ', error);
      })

    },
    GET_BRANCH_MENU({ commit, dispatch, state }, [branchShortCode, companyId]) {
      commit("setMenuLoading", true);
      return new Promise((resolve, reject) => {
        axios({
          headers: headers,
          url: servicesURL.restaurant.getBranchMenu(branchShortCode, companyId),
          method: 'GET'
        }).then(res => {
          commit('setBranchMenu', res.data);
          commit("setMenuLoading", false);
          resolve(res.data)

        }).catch(err => {
          reject(err)
          commit("setMenuLoading", false);
          console.log('error: ', err);
        })
      })
    },
    REMOVE_ALL_ITEMS_FROM_BASKET({ commit, dispatch, state }) {
      commit('setBasketCompactLoading', true);
      commit("setBasketLoading", BasketLoadersEnum.removeAll);

      return axios({
        headers: headers,
        url: servicesURL.basket.delete,
        method: 'DELETE'
      }).then(res => {
        pushAnalyticsEvent(
          analyticsEvents.ordering.category,
          analyticsEvents.ordering.events.deleteBasket(state.basketCompact.data.isGroup),
          analyticsEvents.ordering.labels.basketUUID(state.basketCompact.uuid)
        );
        commit('emptyBasket');
        commit('emptyGroup');
        dispatch("getUserProfileData", false);
        commit('updateBasketState', { state: "NO_BASKET" });
        commit("setBasketLoading", null);
        commit('setBasketCompactLoading', false);
      }).catch(error => {
        commit('updatePromoCode', null);
        console.log('error: ', error);
        commit("setBasketLoading", null);
        commit('setBasketCompactLoading', false);
      })

    },
    ADD_PROMO_TO_BASKET({ commit, state, dispatch }) {
      commit(`setBasketLoading`, BasketLoadersEnum.promo);
      return axios({
        headers: headers,
        url: servicesURL.basket.promo,
        method: 'PUT',
        data: JSON.stringify({ promoCode: state.promoRequest.code })
      }).then(res => {
        commit('updateBasket', res.data);
        commit("setBasketLoading", null);
        commit(`updatePromoErrors`, null);

      }).catch(error => {
        if (error.response.data.error == "BELOW_PROMO_MINIMUM_ORDER_VALUE") {
          commit(`updatePromoErrors`, staticContent.restaurant.checkout.promoErrors.BELOW_PROMO_MINIMUM_ORDER_VALUE(error.response.data.additionalInfo ? error.response.data.additionalInfo.minimumOrderValue : ""));
          EventBus.$emit('openNotyf', ['error', staticContent.restaurant.checkout.promoErrors.BELOW_PROMO_MINIMUM_ORDER_VALUE(error.response.data.additionalInfo ? error.response.data.additionalInfo.minimumOrderValue : "")])
        }
        else if (error.response.data.error == "FIRST_N_ORDER_ONLY") {
          commit(`updatePromoErrors`, staticContent.restaurant.checkout.promoErrors.FIRST_N_ORDER_ONLY(error.response.data.additionalInfo ? error.response.data.additionalInfo.maxNumberOfUsagePerUser : ""));
          EventBus.$emit('openNotyf', ['error', staticContent.restaurant.checkout.promoErrors.FIRST_N_ORDER_ONLY(error.response.data.additionalInfo ? error.response.data.additionalInfo.maxNumberOfUsagePerUser : "")])
        }
        else {
          commit(`updatePromoErrors`, staticContent.restaurant.checkout.promoErrors[error.response.data.error] || staticContent.restaurant.checkout.promoErrors.SOMETHING_WRONG);
          EventBus.$emit('openNotyf', ['error', staticContent.restaurant.checkout.promoErrors[error.response.data.error] || staticContent.restaurant.checkout.promoErrors.SOMETHING_WRONG])
        }
        commit("setBasketLoading", null);
        pushAnalyticsEvent(
          analyticsEvents.ordering.category,
          analyticsEvents.ordering.events.promoError,
          analyticsEvents.ordering.labels.promoName(state.promoRequest.code)
        )
      })

    },
    REMOVE_PROMO_FROM_BASKET({ commit, state, dispatch }) {
      commit(`setBasketLoading`, BasketLoadersEnum.promo);
      return axios({
        headers: headers,
        url: servicesURL.basket.promo,
        method: 'DELETE',
      }).then(res => {
        commit('updateBasket', res.data);
        commit('updatePromoCode', null);
        commit("setBasketLoading", null);
        commit(`updatePromoErrors`, null);
      }).catch(error => {
        commit("setBasketLoading", null);
      })

    },
    APPLY_WALLET_TO_BASKET({ commit, state, dispatch }, applyWallet) {
      commit(`setBasketLoading`, BasketLoadersEnum.applyWallet);
      return axios({
        headers: headers,
        url: servicesURL.basket.wallet,
        method: 'PUT',
        data: JSON.stringify({ applyWallet })
      }).then(res => {
        commit('updateBasket', res.data);
        if (state.basketCompact.data.isGroup) {
          store
          .dispatch("GET_GROUP_BASKET_SUMMARY", state.basketCompact.uuid)
        }
        commit("setBasketLoading", null);
        commit(`updatePromoErrors`, null);
      }).catch(error => {
        let obj = JSON.parse(JSON.stringify(state.basket));
        obj.data.memberReceipt.paidWithWallet = !applyWallet
        commit('updateBasket', obj);
        if (error.response.data.error == "BELOW_PROMO_MINIMUM_ORDER_VALUE") {
          commit(`updatePromoErrors`, staticContent.restaurant.checkout.promoErrors.BELOW_PROMO_MINIMUM_ORDER_VALUE(error.response.data.additionalInfo ? error.response.data.additionalInfo.minimumOrderValue : ""));
          EventBus.$emit('openNotyf', ['error', staticContent.restaurant.checkout.promoErrors.BELOW_PROMO_MINIMUM_ORDER_VALUE(error.response.data.additionalInfo ? error.response.data.additionalInfo.minimumOrderValue : "")])
        }
        else if (error.response.data.error == "FIRST_N_ORDER_ONLY") {
          commit(`updatePromoErrors`, staticContent.restaurant.checkout.promoErrors.FIRST_N_ORDER_ONLY(error.response.data.additionalInfo ? error.response.data.additionalInfo.maxNumberOfUsagePerUser : ""));
          EventBus.$emit('openNotyf', ['error', staticContent.restaurant.checkout.promoErrors.FIRST_N_ORDER_ONLY(error.response.data.additionalInfo ? error.response.data.additionalInfo.maxNumberOfUsagePerUser : "")])
        }
        else {
          commit(`updatePromoErrors`, staticContent.restaurant.checkout.promoErrors[error.response.data.error] || staticContent.restaurant.checkout.promoErrors.SOMETHING_WRONG);
          EventBus.$emit('openNotyf', ['error', staticContent.restaurant.checkout.promoErrors[error.response.data.error] || staticContent.restaurant.checkout.promoErrors.SOMETHING_WRONG])
        }
        commit("setBasketLoading", null);
      })

    },
    APPLY_TOP_UP({ commit, state, dispatch }, data) {
      commit(`setTopupLoading`, true);
      return new Promise((resolve, reject) => {
        axios({
        headers: headers,
        url: servicesURL.topup,
        method: 'POST',
        data
        }).then(res => {
          commit(`setTopupLoading`, false);
          resolve(res)
        }).catch(error => {
          commit('updateTopupErrors', error.response ? error.response.data : error);
          commit(`setTopupLoading`, false);
          reject(error.response);
        })
      })
    },
    GET_USER_BASKET_ADDRESSES({ commit }) {

      commit("setBasketLoading", BasketLoadersEnum.address);
      return axios({
        method: "GET",
        url: servicesURL.basket.adresses,
        headers: headers
      }).then(res => {
        commit('updateBasketUserAddresses', res.data);
        commit("setBasketLoading", null);
        EventBus.$emit('getBasketAddressSuccess', res.data)
      }).catch(error => {
        console.log('error: ', error);
        commit("setBasketLoading", null);
      })
    },
    GET_TASTY_OFFERS({ commit }, userData) {
      commit("setBasketLoading", BasketLoadersEnum.address);
      return axios({
        method: "GET",
        url: servicesURL.discovery.delivery.offers(userData.area, userData.zone, userData.companyId),
        headers: headers
      }).then(res => {
        commit('updateTastyOffers', res.data);
      }).catch(error => {
        console.log('error: ', error);
      })
    },
    PREP_ADD_CREDIT_CARD({ commit }) {
      return axios({
        method: "POST",
        url: servicesURL.creditCards.prepAddCard,
        headers: headers,
        data: { "deviceId": deviceID }
      }).then(res => {
        commit('updateCardRequest', res.data);
      }).catch(error => {
        console.log('error: ', error);
      })
    },
    GENERATE_PAYFORT_SIGNATURE({ commit }, string) {
      return new Promise((resolve, reject) => {
        axios({
          method: "POST",
          url: servicesURL.creditCards.generateSignature,
          headers: headers,
          data: JSON.stringify(string)
        }).then(res => {
          resolve(res.data);
        }).catch(error => {
          console.log('error: ', error);
          reject();
        })
      });
    },
    AUTHORIZE_CREDIT_CARD({ commit, dispatch, state }) {
      headers['Device-ID'] = deviceID;
      axios({
        method: "POST",
        url: servicesURL.creditCards.authorizCard(state.cardRequest.uuid),
        headers: headers,
        data: { "token": state.cardRequest.token_name }

      })
        .then(res => {
          commit('updateCardRequest', res.data);
          if (res.data.responseMessage.toLowerCase() == "success") {
            commit('addCardLoading', false);
            dispatch('GET_USER_CREDIT_CARDS');
            EventBus.$emit('chooseCard', state.cardRequest.uuid);

          }
          else {
            if (res.data.responseCode == 20064) {
              var popUp = window.open(res.data.otpUrl, '_blank', 'width=500, height=500, left=24, top=24, scrollbars, resizable');
              if (popUp == null || typeof (popUp) == 'undefined') {

                commit('addCardError', 'popUpError');
                commit('addCardLoading', false);
                dispatch('PREP_ADD_CREDIT_CARD');
              }
              else {
                popUp.focus();
              }
            }
            else {
              commit('addCardError', res.data.responseCode);
              dispatch('PREP_ADD_CREDIT_CARD');
              commit('addCardLoading', false);
            }
          }

        })
        .catch(error => {
          error.response.data && error.response.data.responseCode ?
            commit('addCardError', error.response.data.responseCode) : commit('addCardError', error);
          dispatch('PREP_ADD_CREDIT_CARD');
          commit('addCardLoading', false);

        })

    },
    VERIFY_CREDIT_CARD({ commit, dispatch, state }) {
      headers['Device-ID'] = deviceID;
      axios({
        method: "POST",
        url: servicesURL.creditCards.verifyCard(state.cardRequest.uuid),
        headers: headers,
        data:
        {
          "fortId": state.cardRequest.fort_id,
          "expiryDate": state.cardRequest.expiry_date,
          "cardType": state.cardRequest.payment_option,
          "representation": state.cardRequest.card_number,
          "token": state.cardRequest.token_name
        }

      })
        .then(res => {

          commit('addCardLoading', false);
          dispatch('GET_USER_CREDIT_CARDS');
          EventBus.$emit('chooseCard', state.cardRequest.uuid);
        })
        .catch(error => {
          console.log('error: ', error);
          commit('addCardError', error);
          dispatch('PREP_ADD_CREDIT_CARD');
          commit('addCardLoading', false);
        })
    },
    UPDATE_USER_BASKET_ADDRESS({ commit }, addressUUID) {
      return axios({
        method: "PUT",
        url: servicesURL.basket.adresses,
        headers: headers,
        data: JSON.stringify({ userAddressUUID: addressUUID }),
      }).then(res => {
        commit('updateBasket', res.data);
        res.data.data.categories && commit('updateBasketItemErrors', res.data.data.categories);
      }).catch(error => {
        console.log('error: ', error);
      })
    },
    PLACE_ORDER({ commit, state, dispatch }, [placeId, companyName]) {
      commit('UpdatePlaceOrderErrors', null);
      headers['Device-ID'] = deviceID;
      return axios({
        method: "POST",
        url: servicesURL.basket.placeOrder(placeId),
        headers: headers,
        data:{isReplacement:false}
      }).then(res => {
        EventBus.$emit('closeChat');
        commit('UpdatePlaceOrderErrors', null);
        commit('updateOrderSuccessVisibility', true);
        commit('updateOrderConfirmation', res.data);
        commit('updateSelectedOrder', res.data.order);
        commit('updateSelectedOrderType', 'CURRENT');
        commit('updateBasketState', 'NO_BASKET');

        EventBus.$emit('placeOrderSuccess');
        
        pushGoogleAnalytics4Event(state.profile, GA4Events.action.placeOrderSuccess, {
          Order_Value: state.basket.data.receipt.total,
          Restaurant_Name: state.basket.ref.restaurant.name,
        });

        // out of the box event by GA 
        window['gtag']('event', 'purchase', {
          "transaction_id": state.basket.checkout.confirmation.order.orderUUID,
          "value": state.basket.checkout.confirmation.order.data.receipt.total,
          "currency": "EGP",
          "tax": state.basket.checkout.confirmation.order.data.receipt.tax,
          "shipping": state.basket.checkout.confirmation.order.data.receipt.deliveryFee,
          "coupon": state.basket.checkout.confirmation.order.data.promoDetails ? state.basket.checkout.confirmation.order.data.promoDetails.code : null
        })

      }).catch(error => {
        console.log("error", error, error.response.data)
        pushAnalyticsEvent(
          analyticsEvents.ordering.category,
          analyticsEvents.ordering.events.placeOrderError
        )
        if (error.response.data.error === "CARD_NOT_VERIFIED") {
          EventBus.$emit('modalToggler', ['credit-card-verification', 'show']);
          commit('enableOrderSubmit')

        }
        else if (error.response.data.error === "LOCATION_PIN_UNAVAILABLE") {
          commit('setCheckoutStep', 1);
          dispatch(`GET_USER_BASKET_ADDRESSES`).then(res => {
            EventBus.$emit('editAddressData', [state.basket.ref.address.uuid, 'map2']);
          })
          commit('enableOrderSubmit')
          commit('UpdatePlaceOrderErrors', error);
        }
        else {
          commit('UpdatePlaceOrderErrors', error);
          commit('enableOrderSubmit')
        }
      })
    },
    PLACE_GIFTING_ORDER({ commit }, data) {
      commit('setGiftingLoading', true);
      return axios({
        method: "POST",
        url: servicesURL.gifting,
        headers: headers,
        data: data
      }).then(res => {

        commit('setGiftingLoading', false);
        commit("setGiftingMessageOpen", true);

        window['gtag']('event', 'purchase', {
          "transaction_id": null,
          "value": 0,
          "currency": "EGP",
          "tax": 0,
          "shipping": 0,
          "coupon": null
        })

      }).catch(error => {
        if (error.response && error.response.data && error.response.data.error === "CARD_NOT_VERIFIED") {
          EventBus.$emit('modalToggler', ['credit-card-verification', 'show']);
        } else {
          commit('setGiftingLoading', false);
          let err = JSON.parse(JSON.stringify(error));
          if (err.message = "Network Error") {
            error = "SOMETHING_WRONG";
          }
          commit('UpdateGiftingErrors', error);
        }
      })
    },

    GET_MY_ORDERS({ commit, dispatch }, [page, pageSize, methodType]) {
      let data =
      {
        orderType: methodType,
        page: page,
        pageSize: pageSize
      }
      if (methodType == 'CURRENT') {
        commit('updateCurrentOrdersLoader', true);
      }
      else {
        commit('updatePreviousOrdersLoader', true);
      }

      return axios({
        method: "POST",
        url: servicesURL.order.getMyOrders,
        headers: headers,
        data: JSON.stringify(data)
      }).then(res => {
        if (res.data.length > 0) {
          dispatch("GET_SPECIFIC_ORDER", [res.data[0].uuid, methodType]);
        }
        if (methodType == 'CURRENT') {
          commit('updateCurrentOrders', res.data);
          commit('updateCurrentOrdersLoader', false);
        }
        else {
          commit('updatePreviousOrders', res.data);
          commit('updatePreviousOrdersLoader', false);
        }
      }).catch(error => {
        if (methodType == 'CURRENT') {
          commit('updateCurrentOrdersLoader', false);
        }
        else {
          commit('updatePreviousOrdersLoader', false);
        }
      })
    },
    GET_SPECIFIC_ORDER({ commit, dispatch }, [orderUUID, type]) {
      commit('updateMyOrdersPageLoader', true);
      commit('updateMyOrdersPageError', false);
      return new Promise((resolve, reject) => {
        return axios({
          method: "GET",
          url: servicesURL.order.getSpecificOrder(orderUUID),
          headers: headers
        })
          .then(res => {
            commit('updateSelectedOrder', res.data);
            commit('updateSelectedOrderType', type)
            commit('updateMyOrdersPageLoader', false);
            commit('updateMyOrdersPageError', false);
            if (type == 'CURRENT') {
              dispatch("GET_SPECIFIC_ORDER_STATUS", true)

            }
            resolve(res);


          })
          .catch(error => {
            commit('updateMyOrdersPageLoader', false);
            commit('updateMyOrdersPageError', true);
            reject(error);
          })
      });
    },

    GET_SPECIFIC_ORDER_STATUS({ commit, state }, firstHit = false) {
      if (firstHit) {
        commit('updateMyOrdersPageLoader', true);
      }
      return new Promise((resolve, reject) => {
        return axios({
          method: "GET",
          url: servicesURL.order.selectedOrderStateDetails(state.selectedOrder.orderUUID),
          headers: headers
        })
          .then(res => {
            commit('updateSelectedOrderState', res.data)
            if (!res.data.tripUUID && (res.data.state == 'ACCEPTED' || res.data.state == 'OUT_FOR_DELIVERY') && moment().diff(moment(res.data.acceptedTime), 'minutes') > res.data.expectedDeliveryTime) {
              commit("updateSelectedOrderStatus", "DELIVERED");
              EventBus.$emit('stopTracking');
            }
            commit('updateMyOrdersPageLoader', false);
            resolve(res);
          })
          .catch(error => {
            reject(error);
          })
      });
    },
    RESUME_ORDER({ commit, dispatch }, orderUUID) {
      axios({
        method: "PUT",
        url: servicesURL.order.resumeOrder(orderUUID),
        headers,
      })
        .then(res => {
          commit("resumeOrderLoading", false);
          EventBus.$emit('modalToggler', ['resume-order-modal', 'hide']);
          EventBus.$emit('modalToggler', ['resume-order-payment-modal', 'hide']);
          commit('updateSelectedOrder', res.data);
          commit('updateMyOrdersPageLoader', false);
          commit('updateMyOrdersPageError', false);
        })
        .catch(error => {

          commit("resumeOrderLoading", false);
          commit("resumeOrderError", true);
        });
    },
    UPDATE_ORDER_ADDRESS({ commit, dispatch, state }, [orderUUID, address]) {
      commit("resumeOrderLoading", true);
      axios({
        method: "PUT",
        url: servicesURL.order.updateOrder.address(orderUUID),
        headers,
        data: JSON.stringify(address)
      })
        .then(res => {
          dispatch('RESUME_ORDER', orderUUID)
        })
        .catch(error => {
          commit("resumeOrderLoading", false);
          commit("resumeOrderError", true);
        });
    },
    UPDATE_ORDER_PAYMENT({ commit, dispatch, state }, [orderUUID, payment]) {

      commit("resumeOrderLoading", true);
      axios({
        method: "PUT",
        url: servicesURL.order.updateOrder.payment(orderUUID),
        headers,
        data: JSON.stringify(payment)
      })
        .then(res => {
          dispatch('RESUME_ORDER', orderUUID)
        })
        .catch(error => {

          commit("resumeOrderLoading", false);
          commit("resumeOrderError", true);
        });
    },
    RE_ORDER({ commit }, orderUUID) {
      return new Promise((resolve, reject) => {
        let data = {
          zoneUUID: getCookie(cookies.userZone)
        }
        commit('setBasketCompactLoading', true);

        axios({
          method: "POST",
          url: servicesURL.order.reOrder(orderUUID),
          headers: headers,
          data: JSON.stringify(data)
        })
          .then(res => {
            commit('updateBasket', res.data);
            commit('updateBasketData', res.data.data);
            res.data.data.categories && commit('updateBasketItemErrors', res.data.data.categories);
            commit('updateBasketRefSummary', res.data.ref);
            commit('updateBasketCompactFromBasket', res.data);
            commit("setBasketLoading", null);
            commit('setBasketCompactLoading', false);
            commit('changeBasketVisibility', true);
            resolve();
          })
          .catch(error => {
            //  if(error.response.status==403){
            //   EventBus.$emit('modalToggler', ['leave-group-modal', 'show']);


            //     //login page
            //   }

            commit("setBasketLoading", null);
            commit('setBasketCompactLoading', false);
            commit('updateBasketError', error.response.data.error);
            EventBus.$emit('basketErrors');
            EventBus.$emit('modalToggler', ['basket-errors-modal', 'show']);

          })
      });
    },
    GET_LAST_ACTIVE_ORDER({ commit }) {
      axios({
        method: "GET",
        url: servicesURL.order.lastOrder,
        headers,
        data: JSON.stringify({
          page: 1,
          pageSize: 20
        })
      })
        .then(res => {
          commit('updateLastOrder', res.data);
        })
        .catch(error => {
          console.log("error", error)
        });
    },
    GET_SPECIFIC_TRIP_STATUS({ commit }, uuid) {
      return new Promise((resolve, reject) => {
        axios.get(servicesURL.TRIPCOMPACT(uuid))
          .then(res => {
            commit('updateSelectedTrip', res.data)
            if ((res.data.status.toUpperCase() == 'ACCEPTED' || res.data.status.toUpperCase() == 'OUT_FOR_DELIVERY') && moment().diff(moment(res.data.acceptedTime), 'minutes') > res.data.expectedDeliveryTime) {
              EventBus.$emit('stopTracking');
            }
            if (
              res.data.status === "Delivered" ||
              res.data.status === "Canceled" ||
              res.data.status === "Rejected"
            ) {
              commit('updateSelectedTrip', { location: null });
            }
            resolve(res.data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    GET_DRIVER_LOCATION({ commit }, tripUUID) {
      return new Promise((resolve, reject) => {
        return axios({
          method: "GET",
          url: servicesURL.trip.getDriverLocation(tripUUID),
          headers: headers
        })
          .then(res => {
            commit('updateDriverData', res.data);
            resolve(res);
          })
          .catch(error => {
            console.log("error", error)
            reject(error);
          })
      });
    },
  }
});



if (serverData.profile) {
  store.commit('updateUserProfile', serverData.profile);
}
